import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Service } from '../../app/service';
import { Question } from '../question/question';

@Component({
  selector: 'page-thema',
  templateUrl: 'thema.html'
})

export class ThemenSelector {

  topics: any;
  level: number;
  mode: any;

  constructor(public navCtrl: NavController, private navParams: NavParams, private DataProvider: Service) {
    this.level = navParams.get('level');
    this.mode = navParams.get('mode');

    console.log("nav", this.level);
    this.topics = DataProvider.getTopics(this.level);
    console.log("topics: ", this.topics);
  }

  openTopic(event, _topic) {
    console.log("open topic", _topic);
    this.navCtrl.push(Question, {mode: this.mode, level: this.level, topic: _topic});
  };

}



// WEBPACK FOOTER //
// ./src/pages/thema/thema.ts